<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
        <li><router-link to="/admin">Dashboard</router-link></li>
        <li class="active">Print Coupons</li>

        
      </ol>
       <div class="panel-body1 locationform">
         <div v-if="ErrorMessage" class="alert alert-danger visibility" role="alert" style="background-color: #f8d7da; color: #721c24; border-color: #f5c6cb; padding: 15px; margin: 15px 0; border: 1px solid transparent; border-radius: 4px; font-weight: 500; visibility: visible !important; display: block !important;">
             {{ ErrorMessage }}
           </div>
           <div v-if="SuccessMessage" class="alert alert-success visibility" role="alert" style="background-color: #d4edda; color: #155724; border-color: #c3e6cb; padding: 15px; margin: 15px 0; border: 1px solid transparent; border-radius: 4px; font-weight: 500; visibility: visible !important; display: block !important;">
             {{ SuccessMessage }}
           </div>
           <div class="row ">
              <div class="col-md-6">
                    <div class="form-group">
                      <label>Product List</label>
                      <Select2SearchWithTokenPrefetch
                        :remoteControl="'kspgAPI/Product/search'"
                        :selectedOptionArray ="roleAlready"
                        @selectedData="ProductSelect"
                      ></Select2SearchWithTokenPrefetch>
                      <span v-if="errors.has('ProductSearch')">
                          {{ errors.first('ProductSearch') }}
                        </span>
                    </div>
                  </div>
                  <div class="col-md-3" v-if="$can('Delete','Loyalty::Coupons')">
                      <div class="form-group">
                        <br>
                        <button  class="btn btn-danger submitbtn btn-raised pull-right" @click="$router.push('PrintCouponsDeleteArchive')">Archive Delete Coupon List</button>
                      </div>
                  </div>
                  <div class="col-md-3" v-if="$can('Delete','Loyalty::Coupons')">
                      <div class="form-group">
                        <br>
                        <button  class="btn btn-danger submitbtn btn-raised pull-right" @click="DeleteSelectedCoupons">Delete All Coupons</button>
                      </div>
                  </div>
                  <div class="col-md-12" style="color: red;    font-weight: bold;    line-height: 30px;text-align: center;">
                      {{loadingMSG}}
                  </div>
            <div class="col-md-12">

<button type="button" class="btn btn-default">Total Coupons <span class="badge"> {{TotalCoupon}}</span></button>

<button type="button" class="btn btn-default">Total Coupon Printed <span class="badge"> {{PrintedCoupon}}</span></button>

<a :href="FileImportLink" v-if="fileName">{{fileName}}</a>
<button @click="print" class="btn btn-primary pull-right" v-if="$can('Create','Loyalty::Coupons')">
  <span class="icon"><i class="material-icons">
                          local_printshop
                          </i></span>
</button>
<!-- <a target="_blank" v-on:click="printApi" class="btn btn-primary pull-right " v-if="$can('Create','Loyalty::Coupons')">
  <span class="icon"><i class="material-icons">
                          local_printshop
                          </i></span>
Print</a> -->

        </div>
               
           <div class="col-md-12">
             <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#
                      <input type="checkbox" v-model="selectAll">
                    </th>
                    <th>Coupon ID</th>
                    <td>Product Name</td>
                    <th>Points</th>
                    <th>QR Code</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in coupon_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>
                      <input type="checkbox" v-model="selected" :value="item.id" number>
                      </td>
                    <td class="left-align">
                      <!-- <router-link
                        :to="{
                          name: 'editReborer',
                          params: { partner_id: item.id },
                        }"
                        ></router-link
                      > -->
                      {{ item.coupon }}
                    </td>
                    <td>{{ item.ProductName }}</td>
                    <td>{{ item.points }}</td>
                    <td><vue-qrcode :value='item.coupon'
                      :quality=0.92
                     :errorCorrectionLevel="'L'"  :color="{ dark: '#000000ff', light: '#ffffffff' }" :type='"image/png"' /></td>
                    <td>{{ item.created_date | dateFormatReadable }}</td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
                <!--end table-->
                 <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
           </div>
           
           </div>
       </div>
       
      </div>
    </div>
     <div id="printMe" style="display:none" >
              <div  v-for="item in printableCoupons" :key="item.id" 
              style="page-break-after: always;">
                <table class="table-borderless" style="font-size:50%" >
                <tbody>
                  <tr>
                  <td>
                    <vue-qrcode :value='item.coupon'
                      :quality=1
                     :errorCorrectionLevel="'H'" :width="75" :height="75"  :color="{ dark: '#000000ff', light: '#ffffffff' }" :type='"image/png"' />
                  </td>
                  <td style="width: 50mm; line-height: 180%;padding-top: 3mm;"><p class="preWrap"><small><b>{{ item.ProductName }}</b></small>
                  <br><small>{{ item.Descriptions }}</small>
                  <br><b>{{item.coupon}}</b>
                  </p></td>
                  </tr>
                </tbody>
              </table>
             
                  </div>      
            </div>
    <!-- Modal for Confirm Print Count -->
    <div v-if="showConfirmModal" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Confirm Print Range</h4>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitConfirmPrint">
                <div class="form-group">
                  <label for="printedCountInput">Last Coupon Code Successfully Printed</label>
                  <input
                    type="text"
                    id="printedCountInput"
                    class="form-control"
                    v-model="lastPrintedCouponCode"
                    placeholder="Enter coupon code (e.g. TEST-CONFIRM-...)"
                  />
                  <small class="form-text text-muted" style="display: block; margin-top: 5px;">
                    Out of {{ printableCoupons ? printableCoupons.length : 0 }} total coupons sent to printer. 
                    Leave empty if no coupons printed successfully.
                  </small>
                </div>
                <div v-if="confirmFormError" class="text-danger" style="margin-bottom: 15px;">{{ confirmFormError }}</div>
                <div class="modal-footer" style="padding-top: 15px; border-top: 1px solid #e5e5e5; display: flex; justify-content: flex-end;">
                  <button type="submit" class="btn btn-success text-white">Confirm</button>
                  <button type="button" class="btn btn-secondary ml-2" @click="closeConfirmModal">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


import VueQrcode from 'vue-qrcode'
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment'
import Select2SearchWithTokenPrefetch from '../components/Select2SearchWithTokenPrefetch';
export default {
  name: 'printCoupons',
  data() {
    return {
      loadingMSG:'',
      SelectStateMaintain:false,
      selected: [],
      roleAlready:{},
      ErrorMessage:'',
      SuccessMessage:'',
      FileImportLink:'',
      fileName:'',
      coupon_data: [],
      All_coupon_data:[],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message:'',
      PrintedCoupon:0,
      TotalCoupon:0,
      product_t_id:'',
      output: null,
      showConfirmModal: false,
      lastPrintedCouponCode: '',
      confirmFormError: ''
    };
  },
  components: {
    Paginate,
   VueQrcode,
   Select2SearchWithTokenPrefetch
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  computed:{
    selectAll: {
      get: function () {
          if(!this.product_t_id){
            return false;
        }
            return this.coupon_data && this.coupon_data.length > 0 ? this.coupon_data.every(d => this.selected.includes(d.id)) : false;
      },
       set: function (value) {
         if(!this.product_t_id){
            alert("Please Select Product ");
            return true;
        }
         var selected = [];
                if (value) {
                    this.All_coupon_data.forEach(function (d) {
                        selected.push(d.id);
                    });
                }
            this.selected = selected;
            this.SelectStateMaintain = value;
       }
    },
    printableCoupons() {
      if (this.selected && this.selected.length > 0) {
        return this.All_coupon_data ? this.All_coupon_data.filter(item => this.selected.map(String).includes(String(item.id))) : [];
      }
      return this.All_coupon_data || [];
    }
  },
  methods: {
    async print () {
      if (!this.printableCoupons || this.printableCoupons.length === 0) {
        alert("No coupons available to print.");
        return false;
      }
      // Pass the element id here
      const options = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=no',
          'scrollbars=no'
        ],
        styles: [
          'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
          'https://unpkg.com/kidlat-css/css/kidlat.css'
        ],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      }
      // await this.$htmlToPaper('printMe',options);
      this.$htmlToPaper('printMe', options, () => {
        this.openConfirmModal();
      });
      
    },
      serialize(obj) {
      var str = [];
      for(var p in obj){
          if (obj.hasOwnProperty(p)) {
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
      }
      return str.join("&");
  },
  DeleteSelectedCoupons(){
    if(!this.product_t_id){
        alert("Please Select Product To process Delete");
        return false;
      }
    if(!confirm('Going to delete All Non Printed Coupons,Are you sure?')){
        return true;
      }
      let APIEndPoint ='';
      const params = this.getRequestParams(
        this.searchText,
        0,
        this.pageSize
      );
      if(!this.SelectStateMaintain)
      { 
        params['SelectedDelete'] = this.selected;
        APIEndPoint = 'selected';
      }
      params['delete'] = "Archive";
       let loader = this.$loading.show();
      commonServices
        .delete('kspgAPI/Coupon/'+APIEndPoint, this.serialize(params))
        .then((response) => {
          if(response.data.status){
            this.SuccessMessage = response.data.message;
            setTimeout(() => (this.SuccessMessage = false), 5000);
          }
          this.getAllCoupons(1);
        })
        .catch((e) => {
           this.ErrorMessage = e.response.data.message;
            setTimeout(() => (this.ErrorMessage = false), 5000);
          if(e.response.data.error == "Invalid API key "){
            loader.hide()
             this.$router.push({ name: 'login'});
          }
           this.getAllCoupons(1);
        });
        setTimeout(() => {loader.hide()}, 1000)
  },
    DeleteCoupons(){
      if(!this.product_t_id){
        alert("Please Select Product To process Delete");
        return false;
      }
      if(!confirm('Going to delete All Non Printed Coupons,Are you sure?')){
        return true;
      }
       const params = this.getRequestParams(
        this.searchText,
        0,
        this.pageSize
      );
      params['delete'] = "Archive";
       let loader = this.$loading.show();
      commonServices
        .delete('kspgAPI/Coupon/', this.serialize(params))
        .then((response) => {
          if(response.data.status){
            this.SuccessMessage = response.data.message;
            setTimeout(() => (this.SuccessMessage = false), 5000);
          }
          this.getAllCoupons(1);
        })
        .catch((e) => {
           this.ErrorMessage = e.response.data.message;
            setTimeout(() => (this.ErrorMessage = false), 5000);
          if(e.response.data.error == "Invalid API key "){
            loader.hide()
             this.$router.push({ name: 'login'});
          }
           this.getAllCoupons(1);
        });
        setTimeout(() => {loader.hide()}, 1000)
    },
    openConfirmModal() {
      if (this.printableCoupons && this.printableCoupons.length > 0) {
        this.lastPrintedCouponCode = this.printableCoupons[this.printableCoupons.length - 1].coupon;
      } else {
        this.lastPrintedCouponCode = '';
      }
      this.confirmFormError = '';
      this.showConfirmModal = true;
    },
    closeConfirmModal() {
      this.showConfirmModal = false;
      this.lastPrintedCouponCode = '';
      this.confirmFormError = '';
    },
    submitConfirmPrint() {
      this.confirmFormError = '';
      let loader = this.$loading.show();
      
      const payload = {
        coupon_ids: this.printableCoupons.map(item => item.id),
        last_printed_coupon_code: this.lastPrintedCouponCode
      };

      commonServices
        .post('kspgAPI/DownloadCoupons/confirmPrint', payload)
        .then((response) => {
          if (response.data && (response.data.status || response.data.status === 1 || response.status === 200)) {
            this.SuccessMessage = response.data.message || 'Print confirmed successfully.';
            this.closeConfirmModal();
            setTimeout(() => {
              this.SuccessMessage = '';
            }, 5000);
          }
          this.getAllCoupons(1);
        })
        .catch((e) => {
          this.confirmFormError = (e.response && e.response.data && e.response.data.message) || 'Error confirming print.';
          if (e.response && e.response.data && e.response.data.error == "Invalid API key ") {
            loader.hide();
            this.$router.push({ name: 'login' });
          }
        })
        .finally(() => {
          setTimeout(() => { loader.hide() }, 1000);
        });
    },
     ProductSelect(val) {
      this.product_t_id = val;
        this.getAllCoupons(1);  
        /*Reset Selected on New Product Selected */
        this.selected = [];
    },
     getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
        if(this.product_t_id)
        {
          params['product_t_id'] = this.product_t_id
        }
        params['ViewName'] = 'Print';
      return params;
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      this.loadingMSG='Loading data, please wait...';
      commonServices
        .get('kspgAPI/DownloadCoupons/couponList', params)
        .then((response) => {
          this.loadingMSG='';
          
          const {
            coupon_data,
            All_coupon_data,
            currentPage
          } = response.data;
          this.coupon_data = coupon_data || [];
          this.All_coupon_data = All_coupon_data || [];
          this.currentPage = currentPage ? parseInt(currentPage) : 1;

          if(this.SelectStateMaintain) {
            this.selectAll =  true;
          }
          this.fetchCounts();
        })
        .catch((e) => {
          loader.hide()
          if(e.response && e.response.data && e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 1000);
    },
    fetchCounts() {
      const params = this.getRequestParams(
        this.searchText,
        null,
        this.pageSize
      );
      commonServices
        .get('kspgAPI/DownloadCoupons/couponListCounts', params)
        .then((response) => {
          const data = response.data || {};
          if (data.TotalPage !== undefined) this.TotalPage = data.TotalPage || 1;
          if (data.PrintedCoupon !== undefined) this.PrintedCoupon = data.PrintedCoupon || 0;
          if (data.TotalCoupon !== undefined) this.TotalCoupon = data.TotalCoupon || 0;
        })
        .catch(() => {
          // Failed to load counts
        });
    },
  },
  created() {this.getAllCoupons(1);},
   mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>

<style>
.preWrap {
  white-space: pre-wrap !important; 
  word-wrap: break-word !important;
  font-family: inherit !important;
  font-size:8 pt;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.btn-success.text-white {
  background-color: #28a745 !important;
  color: #fff !important;
  border: none;
}
.btn-success.text-white:hover,
.btn-success.text-white:focus,
.btn-success.text-white:active {
  background-color: #218838 !important;
  color: #fff !important;
}
.ml-2 {
  margin-left: 8px !important;
}
.text-danger {
  color: #d9534f !important;
}
.visibility {
  visibility: visible !important;
}
</style>